import {inject, Pipe, PipeTransform} from '@angular/core';
import {ConstStore} from "@store/const.store";

@Pipe({
  name: 'agence',
  standalone: true
})
export class AgencePipe implements PipeTransform {


  store = inject(ConstStore);

  transform(value: number, ...args: unknown[]): unknown {
    return this.store.getAgencyById(value)?.name;
  }
}
